module.exports = __webpack_public_path__ + "static/media/chrome.4ed3a9f2.svg";